import { OnDestroy, Pipe, PipeTransform } from '@angular/core'
import {
	Form,
	FormControl,
	FormControlDirective,
	FormGroup,
	NgControl,
} from '@angular/forms'
import { type ValidationRules } from '@lg/shared'
import { BoInfoSymbol } from '@lg/shared/for-apps'
import { ScopeDirective } from '../directives/scope.directive.js'
import { FormDirective } from '../directives/form.directive.js'

export interface FormBinding {
	object: object
	property: string
	formControl: FormControl
	filterFormControl: FormControl
	isRequired: boolean
}

@Pipe({
	name: 'formBinding',
	pure: true,
	standalone: false,
})
export class FormBindingPipe implements PipeTransform, OnDestroy {
	private binding?: FormBinding = undefined
	private directive?: FormControlDirective = undefined
	private forms: FormGroup[] = []
	private name = ''

	private static nameCounter = 1

	constructor(
		private scopeDirective: ScopeDirective,
		private formDirective: FormDirective,
	) {}

	transform(
		bindingObject: object,
		bindingProperty: string,
		validationRules: ValidationRules | undefined,
		$disabled: boolean,
	): FormBinding {
		throw new Error('formBinding pipe is deprecated')
		// this.forms = this.formDirective?.viewRef?.context?.$implicit ?? []
		// if(this.name) {
		// 	for(const form of this.forms) form.removeControl(this.name)
		// }

		// const value = Reflect.get(bindingObject, bindingProperty)
		// const alternativeBindingProperty = this.getAlternativeBindingPropertyOnObject(value)

		// const object = alternativeBindingProperty ? value : bindingObject
		// const property = alternativeBindingProperty || bindingProperty
		// const syncValidator = ValidationUtil.createSyncValidationFunction(validationRules?.sync, this.scopeDirective)
		// const asyncValidator = ValidationUtil.createAsyncValidationFunction(validationRules?.async, this.scopeDirective)

		// const formControlResult = FormControlCache.getFormControl(object, property, true, syncValidator, asyncValidator)
		// const filterFormControlResult = FormControlCache.getFormControl(object, property + 'θfilter', true, null)
		// const formControl = formControlResult.formControl
		// this.binding = {
		// 	object,
		// 	property,
		// 	formControl: formControl!,
		// 	filterFormControl: filterFormControlResult.formControl!,
		// 	isRequired: !!validationRules?.sync.find(rule => rule.name == 'required'),
		// }

		// if(formControl) {
		// 	if($disabled) {
		// 		formControl.disable({ onlySelf: true, emitEvent: false })
		// 	} else {
		// 		formControl.enable({ onlySelf: true, emitEvent: false })
		// 	}
		// 	this.forms = this.forms
		// 	this.name = `fc_${FormBindingPipe.nameCounter++}`
		// 	for(const form of this.forms) form.addControl(this.name, formControl)
		// 	// console.log(this.name, 'added to', this.forms.length)

		// 	if(!validationRules) {
		// 		formControl.clearValidators()
		// 		formControl.clearAsyncValidators()
		// 		formControl.setErrors(null)
		// 	}
		// }

		// return this.binding
	}

	ngOnDestroy(): void {
		if (this.name) {
			for (const form of this.forms) form.removeControl(this.name)
		}
	}

	private getAlternativeBindingPropertyOnObject(value: any) {
		if (value?.[BoInfoSymbol]?.boType == 'StaticEntity') return 'id' // in case of StaticEntity
		return undefined
	}
}
